/* eslint-disable import/prefer-default-export */
export const APIENDPOINT = 'https://newtownrecords.prismic.io/api/v2';

export const TITLE_SUFFIX = 'Newtown Records';
export const URL_ROOT = 'https://www.newtownrecords.nyc';
